import { PartialBlock } from "@blocknote/core";

export function isBlockNoteEmpty(blocks: PartialBlock[]): boolean {
  if (!blocks.length) return true;

  if (blocks.length > 1) return false;

  const firstBlock = blocks[0];
  if (firstBlock.type !== "paragraph") return false;

  const content = firstBlock.content;
  if (!content) return true;

  if (typeof content === "string") return content === "";

  if (Array.isArray(content)) {
    return (
      content.length === 0 ||
      (content.length === 1 &&
        typeof content[0] === "object" &&
        "type" in content[0] &&
        content[0].type === "text" &&
        "text" in content[0] &&
        content[0].text === "")
    );
  }

  return false;
}
